import React, { useState, useMemo } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import get from "lodash/get"
import includes from "lodash/includes"
import { LogoutIcon } from "@infotech/uikit-icons"
import { Box } from "@infotech/uikit-grid"
import { authRequest } from "src/engine/modules/authRequest"
import TopBar, { Name } from "@infotech/uikit-topbar"
import cn from "classnames"
import { getBreadCrumbs, getNamesFromState, getDate } from "./helper"
import env from "src/env"

import styles from "./styles.css"

const { REACT_APP_CUSTOM_LOGO_URL, REACT_APP_LOGO_TOP_BAR_NAME } = env

const PlannerLogo = () => <React.Fragment>
  {REACT_APP_CUSTOM_LOGO_URL && <Link to="/">
    <img src={REACT_APP_CUSTOM_LOGO_URL} alt="" />
  </Link>}
  <Name url="/" withInfotechLogo={!REACT_APP_CUSTOM_LOGO_URL}>
    {
      REACT_APP_CUSTOM_LOGO_URL ? `` : (REACT_APP_LOGO_TOP_BAR_NAME || `Planner`)
    }
  </Name>
</React.Fragment>

const CustomTopBar = props => {
  const {
    toggleMenu,
    isMenuVisible,
    currentUser,
    logout,
    pathname,
    topBarState,
    requestAppList,
    requestFeatureList,
    readNotifications,
    readAllStatuses,
    markOneRead,
    markAllRead,
    applications,
    notificationsData,
    connectWebsocket,
    selectNotificationsAvailable,
    selectStatusAvailable,
  } = props
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [planEventCaseName, setPlanName] = useState(null)

  useMemo(() => {
    const pathParts = pathname.split(`/`).slice(1)
    if (
      pathParts[0] === `plans` &&
      !planEventCaseName &&
      includes(pathParts, `events`) &&
      !topBarState.planName
    ) {
      authRequest({ url: `${pathParts[0]}/${pathParts[1]}` }).then(({ data }) =>
        setPlanName({
          planDate: `${getDate(get(data, `startDateTime`))} - ${getDate(
            get(data, `endDateTime`),
          )}`,
          planName: get(data, `name`),
        }),
      )
    }
  }, [pathname])
  useMemo(() => {
    getBreadCrumbs(pathname, setBreadcrumbs, topBarState, planEventCaseName)
  }, [topBarState])

  useMemo(() => {
    if (currentUser) {
      requestAppList()
      requestFeatureList()
    }
  }, [currentUser])
  useMemo(() => {
    if (currentUser) {
      if (selectNotificationsAvailable) {
        readNotifications()
        connectWebsocket()
      }
    }
  }, [selectNotificationsAvailable])
  useMemo(() => {
    if (currentUser) {
      if (selectStatusAvailable) {
        readAllStatuses()
      }
    }
  }, [selectStatusAvailable])

  const notificationsProp = selectNotificationsAvailable
    ? {
        notifications: notificationsData,
      }
    : {}

  return (
    <Box loose className={styles.TopBarWrapper}>
      <div data-testid="topbar">
        <TopBar
          name={<PlannerLogo />}
          hamburger={{
            onClick: toggleMenu,
            invert: isMenuVisible,
          }}
          applicationsMenu={{
            applications: applications.map(({ host, ...rest }) => ({
              url: `http://${host}`,
              ...rest,
            })),
          }}
          breadcrumbs={breadcrumbs}
          {...notificationsProp}
          onReadNotification={({ uuid }) =>
            markOneRead({ notificationUuid: uuid })
          }
          onReadAllNotifications={markAllRead}
          showReadAllNotificationsButton
          user={
            currentUser
              ? {
                  name: `${get(currentUser, `firstName`, ``)} ${get(
                    currentUser,
                    `lastName`,
                    ``,
                  )}`,
                  pic: get(currentUser, `photo`),
                  email: get(currentUser, `email`),
                  actions: [
                    {
                      Icon: LogoutIcon,
                      label: `Выход`,
                      onClick: logout,
                    },
                  ],
                }
              : {
                  // without it user profile button won't be rendered,
                  // and we wouldn't be able to logout
                  name: ` `,
                  actions: [
                    {
                      Icon: LogoutIcon,
                      label: `Выход`,
                      onClick: logout,
                    },
                  ],
                }
          }
          // TODO remove TemporaryColorFix when hamburger disappears from topbar
          className={cn({ [[styles.TemporaryColorFix]]: isMenuVisible })}
        />
      </div>
    </Box>
  )
}

CustomTopBar.propTypes = {
  applications: PropTypes.arrayOf(
    PropTypes.shape({
      clientId: PropTypes.string,
      host: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  pathname: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  isMenuVisible: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
}

CustomTopBar.defaultProps = {
  applications: [],
}

export default connect(
  (state, { pathname }) => getNamesFromState(state, pathname),
  null,
)(CustomTopBar)
